import { useState } from 'react';
import {
    Collapse,
    Col,
    Row,
} from 'reactstrap';

import EsgRatingsBySource from './EsgRatingsBySource';
import IndustryPeerComparison from './IndustryPeerComparison';

const RatingDetails = ({
    t,
    ratingsBySource,
    peerComparison,
}) => {
    const [isOpen, setIsOpen] = useState(true);

    return (
        <>
            <button
                type="button"
                className="overview-esg-rating__toggle"
                onClick={() => setIsOpen((open) => !open)}
            >
                <span>{t('ESG Rating Details & Peer Comparison')}</span>
                <i className={`ri-arrow-${isOpen ? 'up' : 'down'}-s-line`} />
            </button>

            <Collapse isOpen={isOpen}>
                <Row className="g-3 mb-3 pt-3">
                    <Col xs="12" xl="6">
                        <EsgRatingsBySource
                            t={t}
                            ratings={ratingsBySource}
                        />
                    </Col>

                    <Col xs="12" xl="6">
                        <IndustryPeerComparison
                            t={t}
                            comparisons={peerComparison}
                        />
                    </Col>
                </Row>
            </Collapse>
        </>
    );
};

export default RatingDetails;
